"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var moment_2 = __importDefault(require("@date-io/moment"));
var pickers_1 = require("@material-ui/pickers");
var useUpdateMomentLocale_1 = __importDefault(require("./hooks/useUpdateMomentLocale"));
require("moment/locale/pl");
require("moment/locale/ru");
require("moment/locale/lt");
require("moment/locale/tr");
require("moment/locale/es");
require("moment/locale/uk");
var DatePickerLocalization = function (_a) {
    var locale = _a.locale, children = _a.children;
    (0, useUpdateMomentLocale_1.default)(locale);
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { libInstance: moment_1.default, utils: moment_2.default, locale: locale }, children));
};
exports.default = react_1.default.memo(DatePickerLocalization);
